import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import "./registrati.css";
import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import axios from 'axios';
import Alert from '@mui/material/Alert';
import { Route } from 'react-router-dom';
import { Stack } from '@mui/system';
import Login from './login';
import Link from '@mui/material/Link';
import { red } from '@mui/material/colors';
import { configData } from '../configData/configData';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import logoValuetech from '../image/logoValuetech.png';

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);
const validateForm = errors => {
  let valid = true;
  Object.values(errors).forEach(val => val.length > 0 && (valid = false));
  return valid;
};

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      userName: '',
      email: '',
      password: '',
      showPassword: false,
      exists: '',
      open: false,
      vertical: 'bottom',
      horizontal: 'center',
      errors: {
        fullName: '',
        email: '',
        password: '',
      }
    };
  }



  Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  handleClickPopUp = () => {
    this.setState({ ...this.state, open: true });
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ ...this.state, open: false });
    document.location.href = configData.SITE_URL+"/login";
  };

  handleChange = (prop) => (event) => {
    const value = event.target.value;
    let errors = { ...this.state.errors };

    switch (prop) {
      case 'userName':
        errors.fullName = value.length < 5 ? 'Lo username deve contenere almeno 5 caratteri' : '';
        break;
      case 'email':
        errors.email = validEmailRegex.test(value) ? '' : 'Email non valida!';
        break;
      case 'password':
        errors.password = value.length < 8 ? 'Password deve avere almeno 8 caratteri' : '';
        break;
      default:
        break;
    }

    this.setState({ errors, [prop]: value });
  }


  handleClickShowPassword = () => {
    this.setState({
      ...this.state,
      showPassword: !this.state.showPassword,
    });
  };
  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  handleSubmit = (e) => {
    if (e) e.preventDefault();

    const { userName, email, password } = this.state;

    const isUsernameValid = userName.length >= 5;
    const isPasswordValid = password.length >= 8;
    const isEmailValid = validEmailRegex.test(email);

    if (isUsernameValid && isPasswordValid && isEmailValid) {
      const utente = {
        username: userName,
        email: email,
        password: password
      }

      this.setState({ exists: '' });

      axios.post(configData.API_BASE + '/api/auth/signup', utente).then(
        res => {
          if (res.status >= 200 && res.status < 300) {
            this.handleClickPopUp();
          } else {
            this.setState({ exists: "Errore durante la registrazione. Riprova." });
          }
        }
      ).catch(error => {
        if (error.response) {
          if (error.response.status === 400) {
            this.setState({ ...this.state, exists: error.response.data.message });
          } else {
            this.setState({ ...this.state, exists: "Errore del server: " + error.response.status });
          }
        } else {
          this.setState({ ...this.state, exists: "Impossibile contattare il server. Controlla la tua connessione." });
        }
      })
    } else {
      let msg = "";
      if (!isUsernameValid) msg = "Lo username deve contenere almeno 5 caratteri. ";
      if (!isEmailValid) msg += "Email non valida. ";
      if (!isPasswordValid) msg += "La password deve contenere almeno 8 caratteri.";
      this.setState({ exists: msg });
    }
  }


  render() {
    const { errors } = this.state;
    return (
    <div>
     <div className='fill'>
     <img 
        width={'20%'}
        height={'20%'}
        style={{marginTop:"35px", marginLeft:"40%"}}
        src={logoValuetech}
        alt="Logo" />
     </div>
      <form className='wrapper' onSubmit={this.handleSubmit} style={{ margin:'-40px auto '}}>
        <div className='form-wrapper' style={{ margin:'50px auto'}}>
          <Typography gutterBottom variant="h5" component="div"  className="Controls" noValidate textAlign="center">
            Registrati
          </Typography>
          <pre></pre> 
            <div className='fullName'>
            <Box noValidate autoComplete="off">
              <TextField
                id="outlined-basic"
                label="Username"
                type='text'
                name='userName'
                onChange={this.handleChange('userName')}
                value={this.state.userName}
                variant="outlined"
              />
              <div style={{ textAlign: "center", width: "100%" }}>
                {errors.fullName.length > 0 &&
                  <span className='error'>{errors.fullName}</span>}
              </div>
            </Box>
            </div>

            <div className='email'>
            <Box noValidate autoComplete="off">
              <TextField
                id="outlined-basic-email"
                label="Email"
                type='email'
                name='email'
                onChange={this.handleChange('email')}
                value={this.state.email}
                variant="outlined"
              />
              <div style={{ textAlign: "center", width: "100%" }}>
                {errors.email.length > 0 &&
                  <span className='error'>{errors.email}</span>}
              </div>
            </Box>
            </div>

            <div className='password'>
            <FormControl variant="outlined">
              <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                <OutlinedInput
                  label="Password"
                  id="outlined-adornment-password"
                  name="password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  onChange={this.handleChange('password')}
                  value={this.state.password}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={this.handleClickShowPassword}
                        onMouseDown={this.handleMouseDownPassword}
                        edge="end" >
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              <div style={{ textAlign: "center", width: "100%" }}>
                {errors.password.length > 0 &&
                  <span className='error'>{errors.password}</span>}
              </div>
            </FormControl>
            <pre></pre>  
            </div>
            <div className='submit' >
              <Button type="submit" variant="contained" justifyContent="center" > Conferma </Button>
              <Snackbar open={this.state.open}  anchorOrigin={{vertical:'bottom',horizontal:'center'}}  autoHideDuration={2000} key={this.state.vertical + this.state.horizontal} onClose={this.handleClose}> 
            <Alert  onClose={this.handleClose} severity="success" sx={{ width: '100%' }}>
              Registrazione avvenuta con successo
            </Alert>
          </Snackbar>
            </div>
            <pre></pre>
            <div className="Color">
              {this.state.exists != "" ? this.state.exists : ""}
            </div>
        </div>
      </form>
    </div>
    );
  }
}